import React from 'react';

const TopAssigneesPanel = ({ topAssignees }) => {
  if (!topAssignees || topAssignees.length === 0) {
    return null;
  }

  return (
  <div style={{ 
    background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)', 
    border: '1px solid #7dd3fc', 
    borderRadius: '8px', 
    padding: '16px', 
    marginBottom: '16px' 
  }}>
    <h4 style={{ margin: '0 0 12px 0', color: '#0369a1', fontSize: '16px' }}>
      🏆 Top Patent Holders in Results
    </h4>
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
      {topAssignees.slice(0, 10).map((item, index) => (
        <span 
          key={index}
          style={{
            background: index === 0 ? '#fbbf24' : index === 1 ? '#9ca3af' : index === 2 ? '#cd7c2a' : '#e0f2fe',
            color: index < 3 ? '#1e293b' : '#0369a1',
            padding: '6px 12px',
            borderRadius: '16px',
            fontSize: '13px',
            fontWeight: index < 3 ? '600' : '400'
          }}
        >
          {index + 1}. {item.assignee} ({item.count})
        </span>
      ))}
    </div>
  </div>
  );
};

export default TopAssigneesPanel;
